"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDivinationEventCallbacks = createDivinationEventCallbacks;
function createDivinationEventCallbacks(contextRef) {
    return {
        ai_oracle_draw: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_oracle_draw', __assign({}, (ctx.eventContext && { context: ctx.eventContext })));
        },
        ai_tarot_begin: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_tarot_begin', __assign({}, (ctx.eventContext && { context: ctx.eventContext })));
        },
        ai_tarot_clarifying_card: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_tarot_clarifying_card', __assign({}, (ctx.eventContext && { context: ctx.eventContext })));
        },
        ai_tarot_initial_card: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_tarot_initial_card', __assign({}, (ctx.eventContext && { context: ctx.eventContext })));
        },
    };
}
